(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["massive-art-wheel"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('massive-art-wheel')) {
  customElements.define('massive-art-wheel', class MassiveArtWheel extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.controller = new AbortController();
      const { signal } = this.controller;
      this.cards = Array.from(this.querySelectorAll('[data-art-card]'));
      if (!this.cards.length) return;
      this.stage = this.querySelector('.massive-art-wheel__stage');
      this.dialog = this.querySelector('dialog');
      this.selectionTitle = this.querySelector('[data-art-title]');
      this.selectionPrice = this.querySelector('[data-art-price]');
      this.selectionNumber = this.querySelector('[data-art-number]');
      this.position = 0;
      this.active = 0;
      this.suppressClick = 0;
      this.setAttribute('data-ready', '');
      this.querySelector('[data-art-prev]').addEventListener('click', () => this.go(this.position - 1), { signal });
      this.querySelector('[data-art-next]').addEventListener('click', () => this.go(this.position + 1), { signal });
      this.querySelector('[data-art-open]').addEventListener('click', () => this.open(), { signal });
      this.querySelector('[data-art-close]').addEventListener('click', () => this.dialog.close(), { signal });
      this.querySelector('[data-art-zoom]').addEventListener('click', event => {
        const zoomed = this.dialog.toggleAttribute('data-zoomed');
        event.currentTarget.setAttribute('aria-pressed', String(zoomed));
      }, { signal });
      this.dialog.addEventListener('click', event => {
        if (event.target !== this.dialog) return;
        const rect = this.dialog.getBoundingClientRect();
        if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) this.dialog.close();
      }, { signal });
      this.dialog.addEventListener('close', () => {
        if (this.previousOverflow !== undefined) document.documentElement.style.overflow = this.previousOverflow;
        this.opener?.focus({ preventScroll: true });
      }, { signal });
      this.cards.forEach((card, index) => {
        card.addEventListener('click', event => {
          if (event.ctrlKey || event.metaKey || event.shiftKey || event.altKey) return;
          event.preventDefault();
          if (Date.now() < this.suppressClick) return;
          if (index === this.active) this.open(card);
          else this.go(this.position + this.distance(index));
        }, { signal });
      });
      this.stage.addEventListener('keydown', event => {
        if (event.key === 'ArrowLeft' || event.key === 'ArrowRight') {
          event.preventDefault();
          this.go(this.position + (event.key === 'ArrowRight' ? 1 : -1));
        }
        if (event.key === 'Home' || event.key === 'End') {
          event.preventDefault();
          this.go(event.key === 'Home' ? 0 : this.cards.length - 1);
        }
      }, { signal });
      this.stage.addEventListener('pointerdown', event => {
        if (!event.isPrimary || event.button !== 0) return;
        this.pointer = { id: event.pointerId, x: event.clientX, y: event.clientY, start: this.position, moving: false };
      }, { signal });
      this.stage.addEventListener('pointermove', event => {
        const p = this.pointer;
        if (!p || event.pointerId !== p.id) return;
        const dx = event.clientX - p.x;
        const dy = event.clientY - p.y;
        if (!p.moving) {
          if (Math.abs(dy) > Math.abs(dx) && Math.abs(dy) > 8) { this.pointer = null; return; }
          if (Math.abs(dx) < 8) return;
          p.moving = true;
          this.stage.setPointerCapture(p.id);
          this.setAttribute('data-dragging', '');
        }
        this.position = p.start - dx / (this.cards[0].offsetWidth * .8);
        if (!this.renderFrame) this.renderFrame = requestAnimationFrame(() => { this.renderFrame = 0; this.render(); });
      }, { signal });
      const finish = event => {
        const p = this.pointer;
        if (!p || event.pointerId !== p.id) return;
        this.pointer = null;
        if (p.moving) {
          this.suppressClick = Date.now() + 400;
          this.removeAttribute('data-dragging');
          if (this.stage.hasPointerCapture(p.id)) this.stage.releasePointerCapture(p.id);
          this.go(Math.round(this.position));
        }
      };
      this.stage.addEventListener('pointerup', finish, { signal });
      this.stage.addEventListener('pointercancel', finish, { signal });
      this.stage.addEventListener('lostpointercapture', finish, { signal });
      this.stage.addEventListener('dragstart', event => event.preventDefault(), { signal });
      this.resizeObserver = new ResizeObserver(() => this.render());
      this.resizeObserver.observe(this.stage);
      this.render();
      this.addEventListener('shopify:block:select', () => this.go(0), { signal });
    }
    disconnectedCallback() {
      this.controller?.abort();
      this.controller = null;
      this.resizeObserver?.disconnect();
      cancelAnimationFrame(this.renderFrame);
      if (this.dialog?.open) this.dialog.close();
      if (this.previousOverflow !== undefined) document.documentElement.style.overflow = this.previousOverflow;
    }
    distance(index) {
      const count = this.cards.length;
      return ((index - this.position + count / 2) % count + count) % count - count / 2;
    }
    go(position) {
      this.position = Math.round(position);
      this.render();
    }
    render() {
      const count = this.cards.length;
      const width = this.cards[0].offsetWidth;
      const radius = count > 2 ? (width + 36) / (2 * Math.tan(Math.PI / count)) : width * 1.2;
      this.active = ((Math.round(this.position) % count) + count) % count;
      this.cards.forEach((card, index) => {
        const angle = this.distance(index) * (Math.PI * 2 / Math.max(count, 3));
        const depth = Math.cos(angle);
        const visible = depth > -.15;
        card.style.transform = `translate3d(${Math.sin(angle) * radius}px, ${-18 * (1 - depth)}px, ${(depth - 1) * radius}px) rotateY(${angle * 180 / Math.PI}deg)`;
        card.style.opacity = visible ? String(.45 + .55 * Math.max(depth, 0)) : '0';
        card.style.zIndex = String(Math.round((depth + 1) * 100));
        card.style.pointerEvents = visible ? 'auto' : 'none';
        card.inert = !visible;
        card.tabIndex = index === this.active ? 0 : -1;
        card.setAttribute('aria-current', index === this.active ? 'true' : 'false');
      });
      const current = this.cards[this.active];
      if (this.reportedIndex !== this.active) {
        this.selectionTitle.textContent = current.dataset.title;
        this.selectionPrice.textContent = current.dataset.price;
        this.selectionNumber.textContent = String(this.active + 1).padStart(2, '0');
        this.reportedIndex = this.active;
      }
      this.querySelector('[data-art-prev]').disabled = count < 2;
      this.querySelector('[data-art-next]').disabled = count < 2;
    }
    open(opener) {
      this.opener = opener || this.querySelector('[data-art-open]');
      const card = this.cards[this.active];
      const content = this.querySelectorAll('[data-art-detail]')[this.active].content.cloneNode(true);
      const image = content.querySelector('img');
      const description = content.querySelector('.massive-art-wheel__description');
      this.querySelector('[data-art-media]').replaceChildren(...(image ? [image] : []));
      this.querySelector('[data-art-description]').replaceChildren(description);
      this.querySelector('[data-art-detail-title]').textContent = card.dataset.title;
      this.querySelector('[data-art-detail-price]').textContent = card.dataset.price;
      this.querySelector('[data-art-link]').href = card.href;
      this.dialog.removeAttribute('data-zoomed');
      this.querySelector('[data-art-zoom]').setAttribute('aria-pressed', 'false');
      this.previousOverflow = document.documentElement.style.overflow;
      document.documentElement.style.overflow = 'hidden';
      this.dialog.showModal();
      this.querySelector('[data-art-close]').focus();
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["massive-rail"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('massive-rail')) {
    customElements.define('massive-rail', class extends HTMLElement {
      connectedCallback() {
        if (this.abort) this.abort.abort();
        this.abort = new AbortController();
        const options = { signal: this.abort.signal };
        this.links = [...this.querySelectorAll('[data-rail-select]')];
        this.activeIndex = Math.max(0, this.links.findIndex(link => link.classList.contains('is-selected')));
        this.addEventListener('click', (event) => {
          const direction = event.target.closest('[data-rail-direction]');
          if (direction) {
            this.selectGarment(this.activeIndex + Number(direction.dataset.railDirection), true);
            return;
          }
          const flip = event.target.closest('[data-rail-flip]');
          if (flip) {
            const link = this.links[this.activeIndex];
            if (!link?.querySelector('.massive-rail__back')) return;
            const turned = flip.getAttribute('aria-pressed') !== 'true';
            flip.setAttribute('aria-pressed', String(turned));
            link.style.setProperty('--rail-turn', turned ? '180deg' : '0deg');
            return;
          }
          const link = event.target.closest('[data-rail-select]');
          if (!link || event.ctrlKey || event.metaKey || event.shiftKey || event.altKey) return;
          event.preventDefault();
          this.selectGarment(this.links.indexOf(link), true);
        }, options);
        this.addEventListener('keydown', event => {
          if (!event.target.closest('[data-rail-select]')) return;
          if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;
          event.preventDefault();
          this.selectGarment(this.activeIndex + (event.key === 'ArrowLeft' ? -1 : 1), true);
          this.links[this.activeIndex]?.focus({ preventScroll: true });
        }, options);
        this.addEventListener('shopify:block:select', event => {
          const index = this.links.findIndex(link => link.dataset.railSelect.endsWith('-' + event.detail.blockId));
          if (index >= 0) this.selectGarment(index, true);
        }, options);
        this.addEventListener('change', (event) => {
          if (!event.target.matches('[data-rail-variant]')) return;
          const panel = event.target.closest('[data-rail-panel]');
          panel.querySelector('[data-rail-price]').textContent = event.target.selectedOptions[0].dataset.price;
          panel.querySelector('[data-rail-status]').textContent = '';
        }, options);
        this.addEventListener('submit', event => this.addToCart(event), options);
        this.selectGarment(this.activeIndex, false);
        this.initialFrame = requestAnimationFrame(() => {
          const track = this.querySelector('[data-rail-track]');
          const item = this.links[this.activeIndex]?.parentElement;
          if (item && track.scrollWidth > track.clientWidth) track.scrollLeft = item.offsetLeft + item.offsetWidth / 2 - track.clientWidth / 2;
        });
      }
      disconnectedCallback() { this.abort?.abort(); clearTimeout(this.centerTimer); cancelAnimationFrame(this.initialFrame); }
      selectGarment(index, center) {
        if (!this.links.length) return;
        this.activeIndex = (index + this.links.length) % this.links.length;
        const link = this.links[this.activeIndex];
        this.links.forEach((item, position) => {
          const selected = item === link;
          item.classList.toggle('is-selected', selected);
          item.setAttribute('aria-expanded', String(selected));
          item.style.setProperty('--rail-turn', '0deg');
          item.parentElement.classList.toggle('is-active', selected);
          item.parentElement.style.setProperty('--pose-angle', position < this.activeIndex ? '-68deg' : '68deg');
        });
        this.querySelectorAll('[data-rail-flip]').forEach(button => button.setAttribute('aria-pressed', 'false'));
        this.querySelectorAll('[data-rail-panel]').forEach(panel => { panel.hidden = panel.dataset.railPanel !== link.dataset.railSelect; });
        if (center) {
          clearTimeout(this.centerTimer);
          const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
          this.centerTimer = setTimeout(() => {
            const track = this.querySelector('[data-rail-track]');
            const item = link.parentElement;
            track.scrollTo({ left: item.offsetLeft + item.offsetWidth / 2 - track.clientWidth / 2, behavior: reduced ? 'instant' : 'smooth' });
          }, reduced ? 0 : 660);
        }
      }
      async addToCart(event) {
        const form = event.target;
        if (!form.matches('.massive-rail__form')) return;
        event.preventDefault();
        const button = form.querySelector('[name="add"]');
        if (button.disabled) return;
        const status = form.querySelector('[data-rail-status]');
        const cartLink = form.querySelector('[data-rail-cart]');
        const data = new FormData(form);
        button.disabled = true;
        button.setAttribute('aria-busy', 'true');
        status.textContent = '';
        let themeEvents;
        let deferred;
        try {
          try { themeEvents = await import('@shopify/events'); } catch {}
          const sectionIds = [...new Set([...document.querySelectorAll('cart-items-component[data-section-id]')].map(item => item.dataset.sectionId))].slice(0, 5);
          if (sectionIds.length) data.set('sections', sectionIds.join(','));
          data.set('sections_url', window.location.pathname);
          if (themeEvents?.CartLinesUpdateEvent) {
            const EventClass = themeEvents.CartLinesUpdateEvent;
            deferred = EventClass.createPromise();
            deferred.promise.catch(() => {});
            this.dispatchEvent(new EventClass({
              action: 'add', context: 'product',
              lines: [{ merchandiseId: String(data.get('id')), quantity: 1 }],
              promise: deferred.promise
            }));
          }
          const root = window.Shopify?.routes?.root || '/';
          const response = await fetch(root + 'cart/add.js', { method: 'POST', body: data, headers: { Accept: 'application/json' } });
          const result = await response.json();
          if (!response.ok || result.status) throw new Error(typeof result.description === 'string' ? result.description : this.dataset.error);
          status.textContent = this.dataset.added;
          cartLink.hidden = false;
          if (deferred) {
            try {
              const cartResponse = await fetch(root + 'cart.js', { headers: { Accept: 'application/json' } });
              if (!cartResponse.ok) throw new Error('Cart refresh');
              const cart = await cartResponse.json();
              deferred.resolve({
                cart: themeEvents.CartLinesUpdateEvent.createCartFromAjaxResponse(cart),
                detail: { items: cart.items, source: 'product-form-component', sourceId: form.id, itemCount: 1, sections: result.sections, didError: false }
              });
            } catch (error) { deferred.reject(error); }
          }
        } catch (error) {
          status.textContent = error.message || this.dataset.error;
          deferred?.reject(error);
        } finally {
          button.disabled = false;
          button.removeAttribute('aria-busy');
        }
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
